import { render } from "./EmployerSickLeaveIndexComponent.vue?vue&type=template&id=2b6443ea"
import script from "./EmployerSickLeaveIndexComponent.vue?vue&type=script&lang=js"
export * from "./EmployerSickLeaveIndexComponent.vue?vue&type=script&lang=js"

import exportComponent from "/Users/jellevanoosterbosch/PhpstormProjects/haaer/haaer-app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__